import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Empleado} from "./empleado";
import {EmpleadoService} from "../Services/empleado.service";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {Usuario} from "../usuario/Usuario";
import {UsuarioService} from "../Services/usuario.service";

@Component({
  selector: 'app-empleado',
  templateUrl: './empleado.component.html',
  styleUrls: ['./empleado.component.css']
})
export class EmpleadoComponent implements OnInit {

  msgs: Message[] = [];
  formEmpleado : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  tiposDocumento = [];
  panelRequeridos = false;
  loading = false;
  EmpleadosRegistrados:Empleado[];
  EmpleadoSeleccionado:Empleado;
  tipoGuardado = '';
  TiendasRegistrados:Tienda[];
  usuariosRegistrados:Usuario[];


  constructor(private  servicioUsuario:UsuarioService,
              private servicioTienda:TiendaService,
              private servicioEmpleado:EmpleadoService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesEmpleado();
    this.Cancelar();
    this.poblarTiposDoc();
    this.listarEmpleados();
    this.listarTiendas();
    this.listarUsuarios();
  }

  crearControlesEmpleado(){
    this.formEmpleado = this.fb.group({
      numId:['',Validators.required],
      nombre:['',Validators.required],
      direccion:['',Validators.required],
      telefono:['',Validators.required],
      movil:['',Validators.required],
      tienda_id:['',Validators.required],
      usuario_id:['',Validators.required],

      }
    );

  }
  nuevoEmpleado(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formEmpleado.enable();
    this.formEmpleado.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formEmpleado.reset();
    this.formEmpleado.disable();
    this.panelRequeridos = false;
  }
  poblarTiposDoc(){
    this.tiposDocumento.push({label:'Seleccione un Tipo', value:''});
    this.tiposDocumento.push({label:'C.C', value:'C.C'});
    this.tiposDocumento.push({label:'PASAPORTE', value:''});
    this.tiposDocumento.push({label:'C.E.', value:''});
    this.tiposDocumento.push({label:'DNI', value:''});
    this.tiposDocumento.push({label:'NIT', value:''});
    this.tiposDocumento.push({label:'NUIP', value:''});
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoEmpleado(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioEmpleado.putEmpleado(this.formEmpleado.value,this.EmpleadoSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarEmpleados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioEmpleado.addEmpleado(this.formEmpleado.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarEmpleados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarEmpleados(){
    this.loading = true;
    this.servicioEmpleado.getEmpleado()
      .subscribe(
        rt => {
          this.EmpleadosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarEmpleado(item:Empleado){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formEmpleado.enable();
    this.panelRequeridos = true;
    this.EmpleadoSeleccionado = item;
    this.EmpleadoDetalle(item);
    this.tipoGuardado = 'editar';
  }
  EmpleadoDetalle(item:Empleado):void {
    this.formEmpleado.patchValue({
      id:item.id,
      numId:item.numId,
      nombre:item.nombre,
      direccion:item.direccion,
      telefono:item.telefono,
      movil:item.movil,
      tienda_id:item.tienda_id,
      usuario_id:item.usuario_id,


    });
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarUsuarios(){
    this.loading = true;
    this.servicioUsuario.getUsuario()
      .subscribe(
        rt => {
          this.usuariosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });
  }

}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/empleado/empleado.component.ts